import Vue from 'vue'
import Router from 'vue-router'
import store from "./store/store";
import { checkLoginState } from "./utils/requestHelpers"

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

      {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
        path: '/',
        redirect: '/home',
        component: () => import('./layouts/main/Main.vue'),
        children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
          {
            path: '/home',
            name: 'home',
            component: () => import('./views/Home.vue'),
            beforeEnter: (to,from,next) => {
                checkLoginState()
                next()
            }
          },
          {
            path: '/device-manager',
            name: 'device-manager',
            component: () => import('./views/DeviceManager.vue'),
            beforeEnter: (to,from,next) => {
              checkLoginState()
              next()
            }
          },
          {
            path: '/account',
            name: 'account',
            component: () => import('./views/Account.vue'),
            beforeEnter: (to,from,next) => {
              checkLoginState()
              next()
            }
          },
          {
            path: '/hardware-configuration',
            name: 'hardware-configuration',
            component: () => import('./views/HardwareConfiguration.vue'),
            beforeEnter: (to,from,next) => {
              checkLoginState()
              next()
            }
          },
        ],
      },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
      {
        path: '',
        component: () => import('@/layouts/full-page/FullPage.vue'),
        children: [
      // =============================================================================
      // PAGES
      // =============================================================================
          {
            path: '/login',
            name: 'pageLogin',
            component: () => import('@/views/pages/Login.vue'),
            beforeEnter: (to,from,next) => {
            if (store.getters.getloggedState){
              router.push('/home')
            }
            next()
            }
          },
          {
            path: '/error-404',
            name: 'pageError404',
            component: () => import('@/views/pages/Error404.vue')
          },
          {
            path: '/register',
            name: 'pageRegister',
            component: () => import('@/views/pages/Register.vue'),
            meta: {
              rule: 'editor'
            }
          },
          {
            path: '/forgot-password',
            name: 'pageForgotPassword',
            component: () => import('@/views/pages/ForgotPassword.vue'),
            meta: {
                rule: 'editor'
            }
          },
          {
            path: '/reset-password/:token',
            name: 'pageResetPassword',
            component: () => import('@/views/pages/ResetPassword.vue'),
            props: true,
            meta: {
                rule: 'editor'
            }
          },
        ]
      },
      // Redirect to 404 page, if no match found
      {
        path: '*',
        redirect: '/error-404'
      }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
